module.exports = __webpack_public_path__ + "static/career-changers-desktop.b2374b8d.webp";